
import { post,get } from '../utils/http';

export function userLogin(param) {
    return post('login', param);
}

export function getProfile(param) {
    return get('profile', param);
}